
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacMenu from './BacMenu.vue'

@Component({
  components: {
    BacMenu
  }
})
export default class BacLoggedInHeader extends Vue {
  @Prop({ default: false }) wide!: boolean

  get customer () {
    if (!this.$store.state.LoggedInUser.user.id) {
      this.$store.dispatch('loadLoggedInUser')
      return ''
    } else {
      return this.$store.state.LoggedInUser.user
    }
  }
}
